// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-options-container {
    max-width: 1200px;
    margin: 20px auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.admin-title {
    font-size: 24px;
    color: #333;
    text-align: center;
    margin-bottom: 20px;
}

.select-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.select-label {
    font-size: 18px;
    color: #555;
}

.select-table {
    padding: 8px 12px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    color: #333;
}

.manage-title {
    font-size: 20px;
    color: #333;
    margin-bottom: 10px;
}

.options-list {
    list-style: none;
    padding: 0;
    margin-bottom: 20px;
}

.option-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.option-input {
    flex-grow: 1;
    padding: 8px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
}

.delete-button {
    padding: 8px 16px;
    font-size: 14px;
    color: #fff;
    background-color: #e74c3c;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.delete-button:hover {
    background-color: #c0392b;
}

.new-option-container {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.new-option-input {
    flex-grow: 1;
    padding: 8px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
}

.add-button {
    background-color: #44ACC9; /* Egyezik a .szak-button háttérszínével */
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
}

.add-button:hover {
    background-color: #357a9d; /* Egyezik a .szak-button hover színével */
}
`, "",{"version":3,"sources":["webpack://./src/routes/AdminOptions.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB,EAAE,0CAA0C;IACrE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB,EAAE,0CAA0C;AACzE","sourcesContent":[".admin-options-container {\n    max-width: 1200px;\n    margin: 20px auto;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.admin-title {\n    font-size: 24px;\n    color: #333;\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.select-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.select-label {\n    font-size: 18px;\n    color: #555;\n}\n\n.select-table {\n    padding: 8px 12px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #fff;\n    color: #333;\n}\n\n.manage-title {\n    font-size: 20px;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.options-list {\n    list-style: none;\n    padding: 0;\n    margin-bottom: 20px;\n}\n\n.option-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.option-input {\n    flex-grow: 1;\n    padding: 8px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    margin-right: 10px;\n}\n\n.delete-button {\n    padding: 8px 16px;\n    font-size: 14px;\n    color: #fff;\n    background-color: #e74c3c;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.delete-button:hover {\n    background-color: #c0392b;\n}\n\n.new-option-container {\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.new-option-input {\n    flex-grow: 1;\n    padding: 8px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    margin-right: 10px;\n}\n\n.add-button {\n    background-color: #44ACC9; /* Egyezik a .szak-button háttérszínével */\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s ease;\n}\n\n.add-button:hover {\n    background-color: #357a9d; /* Egyezik a .szak-button hover színével */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
